/**
 * resolveKitRowColumnCalc
 *
 * Pure precedence merge for kit-row column scaling rules.
 *
 * Per typeId: Table > Form > Global default (`KIT_ROW_COLUMN_CALC_DEFAULTS`).
 * Rules for distinct typeIds coexist — only same-typeId entries override.
 */

import { KIT_ROW_COLUMN_CALC_DEFAULTS } from '#types/System.Parameters.types';
import type { KitRowColumnCalc, TypeId } from '#types/System.Artifacts.types';

function resolveKitRowColumnCalc(
  table?: ReadonlyArray<KitRowColumnCalc>,
  form?: ReadonlyArray<KitRowColumnCalc>,
): KitRowColumnCalc[] {
  const byTypeId = new Map<TypeId, KitRowColumnCalc>();
  for (const c of KIT_ROW_COLUMN_CALC_DEFAULTS) byTypeId.set(c.typeId, c);
  for (const c of form ?? []) byTypeId.set(c.typeId, c);
  for (const c of table ?? []) byTypeId.set(c.typeId, c);
  return Array.from(byTypeId.values());
}

export { resolveKitRowColumnCalc };
